export const GET_AGENTS: '@geolocAgent/GET_AGENTS' = '@geolocAgent/GET_AGENTS';
export const SET_AGENTS: '@geolocAgent/SET_AGENTS' = '@geolocAgent/SET_AGENTS';
export const GET_AGENTS_FAILED: '@geoloc/GET_AGENTS_FAILED' =
  '@geoloc/GET_AGENTS_FAILED';
export const GET_CITIES: '@geoloc/GET_CITIES' = '@geoloc/GET_CITIES';
export const GET_CITIES_SUCCESS: '@geoloc/GET_CITIES_SUCCESS' =
  '@geoloc/GET_CITIES_SUCCESS';
export const GET_CITIES_FAILED: '@geoloc/GET_CITIES_FAILED' =
  '@geoloc/GET_CITIES_FAILED';
